import { useCallback } from 'react';

import {
  LoginWithRedirectCallbackOptions,
  useLoginWithRedirectCallback,
} from '../../auth/redirect/useLoginWithRedirectCallback';
import { LoginExperience } from '../../auth/types';
import { PROVIDER_PATH } from '../../config';

type ProviderLoginCallbackOptions = Pick<Partial<LoginWithRedirectCallbackOptions>, 'openUrl' | 'returnTo'>;

export function useProviderLoginCallback() {
  const loginWithRedirect = useLoginWithRedirectCallback();

  return useCallback(
    ({ openUrl, returnTo }: ProviderLoginCallbackOptions = {}) => {
      loginWithRedirect({ openUrl, returnTo: returnTo ?? PROVIDER_PATH, loginExperience: LoginExperience.PROVIDER });
    },
    [loginWithRedirect],
  );
}
